import React, { useMemo, useState } from 'react';
import { IEventCalendarCard, TView } from "../../type/events.types";
import moment from "moment";
import EventCalendarView from "./event-calendar.view";
import { getMonthFromRange } from "../../utils/utils";
import Locale from "../../../../core/locale/locale";
import dayjs from "dayjs";


const EventCalendar: React.FC<IEventCalendarCard> = (props) => {

    const [view, setView] = useState<TView>('month');

    const mergeDateTime = (date: string | Date, time: string) => {
        const tempDate = new Date(date);
        return new Date(Date.parse(tempDate.toDateString() + ' ' + time));
    }

    const mappedData = useMemo(() => {
        const birthdayData = props.eventData.birthdays || [];
        const anniversaryData = props.eventData.workAnniversaries || [];
        const eventData = [...props.eventData.events || [], ...props.eventData.trainingEvents || []];

        const mapped = [
            ...birthdayData.map((tempEvent: any) => {
                const originalStart = moment(tempEvent.startDate);
                const eventDate = originalStart.clone().year(moment().year()).toDate();
                return {
                    id: tempEvent.id,
                    title: tempEvent.name,
                    start: eventDate,
                    end: eventDate,
                    description: tempEvent.description,
                    eventType: tempEvent.eventType,
                    hostBy: tempEvent.hostBy,
                    venue: tempEvent.venue,
                    photoCount: tempEvent.photoCount,
                    profilePhoto: tempEvent.profilePhoto,
                    coverImage: tempEvent.coverImage,
                    eventStatus: tempEvent.eventStatus,
                };
            }),
            ...anniversaryData.map((tempEvent: any) => {
                const originalStart = moment(tempEvent.startDate);
                const eventDate = originalStart.clone().year(moment().year()).toDate();
                return {
                    id: tempEvent.id,
                    title: tempEvent.name,
                    start: eventDate,
                    end: eventDate,
                    description: tempEvent.description,
                    eventType: tempEvent.eventType,
                    hostBy: tempEvent.hostBy,
                    venue: tempEvent.venue,
                    photoCount: tempEvent.photoCount,
                    coverImage: tempEvent.coverImage,
                    eventStatus: tempEvent.eventStatus,
                };
            }),
            ...eventData.map((tempEvent: any) => {

                const combinedStartDateTime = `${tempEvent.startDate}T${tempEvent.startTime}`;
                const startTime = dayjs(combinedStartDateTime).format(Locale.displayTimeShort);
                const combinedEndDateTime = `${tempEvent.endDate}T${tempEvent.endTime}`;
                const endTime = dayjs(combinedEndDateTime).format(Locale.displayTimeShort);

                return {
                    id: tempEvent.id,
                    title: tempEvent.name,
                    start: moment(mergeDateTime(tempEvent.startDate, tempEvent.startTime)).toDate(),
                    end: moment(mergeDateTime(tempEvent.endDate, tempEvent.endTime)).toDate(),
                    startTime: startTime,
                    endTime: endTime,
                    description: tempEvent.description,
                    hostBy: tempEvent.hostBy,
                    venue: tempEvent.venue,
                    eventType: tempEvent.eventType,
                    coverImage: tempEvent.coverImage,
                    photoCount: tempEvent.photoCount,
                    eventStatus: tempEvent.eventStatus,
                }
            })
        ];
        return mapped;
    }, [
        props.eventData
    ]);

    function updateView(val: TView) {
        setView(val);
    }

    async function handleRangeChange(
        range: Date[] | { start: Date; end: Date }
    ) {
        let startDate;
        let endDate;
        if (!Array.isArray(range)) {
            // Month View
            const result = getMonthFromRange(range.start, range.end);
            startDate = result.startDate;
            endDate = result.endDate;
            setView('month');
        } else if (range.length > 1) {
            // Week View
            const result = getMonthFromRange(range[0], range[range.length - 1]);
            startDate = result.startDate;
            endDate = result.endDate;
            setView('week');
        } else {
            // Day View
            const result = getMonthFromRange(range[0], range[0]);
            startDate = result.startDate;
            endDate = result.endDate;
            setView('day');
        }

        props.onRangeChange(startDate, endDate);
    }

    return (
        <EventCalendarView
            isAdmin={props.isAdmin}
            data={mappedData}
            openEditEventModal={props.openEditEventModal}
            handleDeleteEvent={props.handleDeleteEvent}
            handleCancelEvent={props.handleCancelEvent}
            handleRangeChange={handleRangeChange}
            activeRange={props.activeRange}
            updateView={updateView}
            view={view}
        />
    )
}

export default EventCalendar;
